import React, { useState, useEffect } from 'react';

const THINKING_MESSAGES = [
  'AI 正在分析流程需求',
  'AI 正在規劃節點結構',
  'AI 正在建立節點連接',
  'AI 正在最佳化流程架構',
];

const ORBIT_ANGLES = [0, 60, 120, 180, 240, 300];

const SPARKS = [
  { left: '15%', top: '20%', delay: '0s',   dur: '2.8s' },
  { left: '80%', top: '15%', delay: '0.5s', dur: '3.2s' },
  { left: '25%', top: '70%', delay: '1.0s', dur: '2.5s' },
  { left: '70%', top: '65%', delay: '1.5s', dur: '3.6s' },
  { left: '50%', top: '10%', delay: '0.8s', dur: '2.9s' },
  { left: '88%', top: '45%', delay: '0.3s', dur: '3.1s' },
  { left: '10%', top: '50%', delay: '1.8s', dur: '2.7s' },
  { left: '60%', top: '82%', delay: '1.2s', dur: '3.4s' },
];

const AIGeneratingOverlay = ({ visible, t }) => {
  const [msgIndex, setMsgIndex] = useState(0);
  const [entering, setEntering] = useState(false);

  useEffect(() => {
    if (!visible) {
      setMsgIndex(0);
      return;
    }
    setEntering(true);
    const msgTimer = setInterval(() => setMsgIndex(i => (i + 1) % THINKING_MESSAGES.length), 2800);
    return () => {
      clearInterval(msgTimer);
      setEntering(false);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="wf-ai-overlay">
      {/* Background floating sparks */}
      {SPARKS.map((s, i) => (
        <div
          key={i}
          className="wf-ai-spark"
          style={{ left: s.left, top: s.top, animationDelay: s.delay, animationDuration: s.dur }}
        />
      ))}

      {/* Center group */}
      <div className="wf-ai-scene">
        {/* Sonar rings */}
        <div className="wf-ai-ring" style={{ animationDelay: '0s' }} />
        <div className="wf-ai-ring" style={{ animationDelay: '0.9s' }} />
        <div className="wf-ai-ring" style={{ animationDelay: '1.8s' }} />

        {/* Rotating orbit with satellites */}
        <div className="wf-ai-orbit">
          {ORBIT_ANGLES.map((angle, i) => (
            <div
              key={i}
              className="wf-ai-sat-arm"
              style={{ transform: `rotate(${angle}deg) translateX(68px) translate(-50%, -50%)` }}
            >
              <div
                className="wf-ai-sat-dot"
                style={{ animationDelay: `${i * 0.28}s` }}
              />
            </div>
          ))}
        </div>

        {/* Center core */}
        <div className="wf-ai-core">
          <img
            src="/assets/wtf-logo.png"
            alt="AI"
            className="wf-ai-icon"
          />
        </div>
      </div>

      {/* Thinking text */}
      <div key={msgIndex} className="wf-ai-msg">
        {THINKING_MESSAGES[msgIndex]}
      </div>

      {/* Bouncing dots */}
      <div className="wf-ai-dots">
        {[0, 1, 2].map(i => (
          <span key={i} className="wf-ai-dot" style={{ animationDelay: `${i * 0.22}s` }} />
        ))}
      </div>

      {/* Hint */}
      <div className="wf-ai-hint">
        {t?.('workflowDesigner.aiChat.generatingHint') || '這可能需要 15–60 秒，請耐心等候'}
      </div>
    </div>
  );
};

export default AIGeneratingOverlay;
